/**
 * Pixellars brand mark + wordmark.
 *
 * The mark is a "pixel-spark": a rounded accent tile carrying the classic
 * generative-AI twin sparkle — the small second star nods to the platform's
 * ✦ Generate motif, and the crisp geometric build reads as "pixel". Colours
 * are theme tokens, so the logo recolours correctly in light/dark.
 */

// Symmetric 4-point sparkle path (built from center/radius/waist — see favicon.svg).
const BIG_SPARKLE =
  'M13 7 C13 13.5 16.5 17 23 17 C16.5 17 13 20.5 13 27 C13 20.5 9.5 17 3 17 C9.5 17 13 13.5 13 7 Z';
const SMALL_SPARKLE =
  'M24 5.5 C24 8.4 26.4 10 28.5 10 C26.4 10 24 11.6 24 14.5 C24 11.6 21.6 10 19.5 10 C21.6 10 24 8.4 24 5.5 Z';

export function LogoMark({ className = 'size-7' }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={`${className} shrink-0`} role="img" aria-label="Pixellars">
      <defs>
        <linearGradient id="pixellars-tile" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--accent-strong)" />
          <stop offset="1" stopColor="var(--accent)" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#pixellars-tile)" />
      <path d={BIG_SPARKLE} fill="var(--accent-contrast)" />
      <path d={SMALL_SPARKLE} fill="var(--accent-contrast)" opacity="0.92" />
    </svg>
  );
}

export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <LogoMark className="size-7" />
      {/* Wordmark collapses on very small screens; the mark always shows. */}
      <span className="display hidden text-[15px] leading-none tracking-tight sm:inline" style={{ letterSpacing: '-0.01em' }}>
        PIXELLARS
      </span>
    </span>
  );
}
